import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ButtonNewComponent,
  ComingSoonButtonComponent,
  IconButtonComponent,
  CrossButtonComponent,
  ActionBoxComponent,
  PaginationButtonsComponent,
} from './components';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';

@NgModule({
  imports: [CommonModule, SvgIconsModule, LoadersModule, TranslateModule],
  declarations: [
    ButtonNewComponent,
    ComingSoonButtonComponent,
    IconButtonComponent,
    CrossButtonComponent,
    ActionBoxComponent,
    PaginationButtonsComponent
  ],
  exports: [
    ButtonNewComponent,
    ComingSoonButtonComponent,
    IconButtonComponent,
    CrossButtonComponent,
    ActionBoxComponent,
    PaginationButtonsComponent
  ]
})
export class ButtonsModule {}
